(() => {
  'use strict';

  if (window.__nuitigoInteractionsLoaded) return;
  window.__nuitigoInteractionsLoaded = true;

  const openMenuSelector = '.n-header details[open]';
  const privacyScriptUrl = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
  const unavailableMessage = 'Le panneau est momentanément indisponible. Réessayez dans quelques instants.';
  let privacyLoading = null;
  let preferencesPending = false;

  function closeMenu(menu) {
    menu.querySelectorAll('details[open]').forEach((child) => { child.open = false; });
    menu.open = false;
  }

  function hasPrivacyPanel() {
    return typeof window.privacyBanner?.showPreferences === 'function';
  }

  function loadPrivacyPanel() {
    if (hasPrivacyPanel()) return Promise.resolve();
    if (privacyLoading) return privacyLoading;

    // Load only Shopify's native preferences UI, on request. Never select consent.
    privacyLoading = new Promise((resolve, reject) => {
      let script = Array.from(document.scripts).find((item) => item.src === privacyScriptUrl);
      const createdHere = !script;
      if (!script) {
        script = document.createElement('script');
        script.src = privacyScriptUrl;
        script.async = true;
      }

      let settled = false;
      const timeout = window.setTimeout(() => finish(false), 10000);
      const loaded = () => finish(hasPrivacyPanel());
      const failed = () => finish(false);

      function finish(available) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        script.removeEventListener('load', loaded);
        script.removeEventListener('error', failed);
        if (available) {
          resolve();
        } else {
          if (createdHere) script.remove();
          reject(new Error('Shopify privacy preferences unavailable'));
        }
      }

      script.addEventListener('load', loaded, { once: true });
      script.addEventListener('error', failed, { once: true });
      if (createdHere) document.head.appendChild(script);
    }).catch((error) => {
      privacyLoading = null;
      throw error;
    });

    return privacyLoading;
  }

  async function showCookiePreferences(button) {
    if (preferencesPending || button.disabled) return;
    preferencesPending = true;
    const scope = button.closest('footer') || document;
    const status = scope.querySelector('[data-cookie-status]');
    const previousBusy = button.getAttribute('aria-busy');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) { status.textContent = ''; status.hidden = true; }

    try {
      await loadPrivacyPanel();
      // This opens Shopify's existing choices; no consent value is written here.
      await window.privacyBanner.showPreferences();
    } catch (_) {
      if (status) { status.textContent = unavailableMessage; status.hidden = false; }
    } finally {
      preferencesPending = false;
      button.disabled = false;
      if (previousBusy === null) button.removeAttribute('aria-busy');
      else button.setAttribute('aria-busy', previousBusy);
    }
  }

  // Delegation also covers header/footer replacements on shopify:section:load.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    document.querySelectorAll(openMenuSelector).forEach((menu) => {
      if (!menu.contains(target)) closeMenu(menu);
    });

    const button = target.closest('[data-cookie-preferences]');
    if (button) {
      event.preventDefault();
      showCookiePreferences(button);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return;
    const target = event.target instanceof Element ? event.target : null;
    // Leave Escape and focus management to an open cart or other modal.
    if (target?.closest('dialog[open], [aria-modal="true"]')) return;

    let menu = target?.closest(openMenuSelector);
    if (!menu) {
      const openMenus = Array.from(document.querySelectorAll(openMenuSelector));
      menu = openMenus.reverse().find((item) => item.getClientRects().length > 0);
    }
    if (!menu) return;

    event.preventDefault();
    closeMenu(menu);
    const summary = Array.from(menu.children).find((child) => child.tagName === 'SUMMARY');
    if (summary) summary.focus({ preventScroll: true });
  });
})();
